// src/oura/merchant/VisibilityTabs.tsx
//
// The two tabs on the merchant's Visibility item: AI Visibility and Website.
// The rail stays at five items, so Website is reached from here, not from the
// menu. Each tab is its own address (/oura/questions, /oura/setup); a past
// scan picked on one stays picked on the other. Underlined page tabs, the
// house style for a page's top-level sections (PageTabs, shared with the staff
// Documents page).

import { useLocation, useNavigate } from "react-router-dom";
import { GlobeIcon, EyeIcon } from "lucide-react";
import { PageTabs, type PageTab } from "@oura/ui";
import { ouraHref } from "../nav";

type VisibilityTab = "questions" | "setup";

// The rail's own glyphs for the same two pages.
const ITEMS: PageTab<VisibilityTab>[] = [
    { key: "questions", label: "AI Visibility", icon: EyeIcon },
    { key: "setup", label: "Website", icon: GlobeIcon },
];

export function VisibilityTabs({ value }: { value: VisibilityTab }) {
    const navigate = useNavigate();
    const { search } = useLocation();
    const open = (key: VisibilityTab) => {
        if (key === value) return;
        const scan = new URLSearchParams(search).get("scan");
        const to = ouraHref(key, { role: "oura-client" });
        navigate(scan ? `${to}?scan=${encodeURIComponent(scan)}` : to);
    };
    return <PageTabs label="Visibility" items={ITEMS} value={value} onOpen={open} />;
}
